import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CollapseService {

  constructor() { }
  isCollapsable(node: any) {
    const links = node.connectedEdges('[source="' + node.data('id') + '"]');
    return links.length !== 0;
  }
}
